// PC端左右滑动指令
export default {
  inserted(el, binding) {
    // 初始化拖动滚动功能
    initDragScroll(el, binding.value);
  },
  update(el, binding) {
    // 如果绑定值变化，重新初始化
    if (binding.value !== binding.oldValue) {
      removeDragScroll(el);
      initDragScroll(el, binding.value);
    }
  },
  unbind(el) {
    // 组件销毁时移除事件监听
    removeDragScroll(el);
  }
};

function initDragScroll(el, options = {}) {
  // 移除已存在的事件监听（如果有）
  removeDragScroll(el);
  
  // 设置样式
  el.style.scrollbarWidth = 'none'; /* Firefox */
  el.style.msOverflowStyle = 'none'; /* IE and Edge */
  el.style.cursor = 'grab';
  el.style.userSelect = 'none';
  
  // 创建样式表以隐藏滚动条
  const styleSheet = document.createElement('style');
  styleSheet.textContent = `
    .drag-scroll-container::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
    .drag-scroll-container:active {
      cursor: grabbing;
    }
  `;
  document.head.appendChild(styleSheet);
  el._dragScrollStyleSheet = styleSheet;
  
  // 添加类名
  el.classList.add('drag-scroll-container');
  
  // 鼠标事件处理函数
  let isDown = false;
  let startX;
  let scrollLeft;
  let hasMoved = false; // 新增：标记是否发生了移动
  let startTime; // 新增：记录按下的时间
  
  const mouseDownHandler = (e) => {
    isDown = true;
    hasMoved = false; // 重置移动标记
    startTime = new Date().getTime(); // 记录开始时间
    el.style.cursor = 'grabbing';
    startX = e.pageX - el.offsetLeft;
    scrollLeft = el.scrollLeft;
    e.preventDefault();
    
    // 调用自定义的mouseDown回调（如果有）
    if (options && typeof options.onMouseDown === 'function') {
      options.onMouseDown(e);
    }
  };
  
  const mouseLeaveHandler = () => {
    isDown = false;
    el.style.cursor = 'grab';
    
    // 调用自定义的mouseLeave回调（如果有）
    if (options && typeof options.onMouseLeave === 'function') {
      options.onMouseLeave();
    }
  };
  
  const mouseUpHandler = (e) => {
    if (isDown) {
      isDown = false;
      el.style.cursor = 'grab';
      
      // 计算按下的时间
      const endTime = new Date().getTime();
      const timeElapsed = endTime - startTime;
      
      // 如果发生了移动或按下时间超过200毫秒，阻止点击事件
      if (hasMoved || timeElapsed > 200) {
        e.stopPropagation();
        // 阻止后续的点击事件
        const preventClickEvent = (clickEvent) => {
          clickEvent.stopPropagation();
          document.removeEventListener('click', preventClickEvent, true);
        };
        document.addEventListener('click', preventClickEvent, true);
      }
      
      // 调用自定义的mouseUp回调（如果有）
      if (options && typeof options.onMouseUp === 'function') {
        options.onMouseUp(e);
      }
    }
  };
  
  const mouseMoveHandler = (e) => {
    if (!isDown) return;
    
    const x = e.pageX - el.offsetLeft;
    const walk = (x - startX) * (options.speed || 2); // 滚动速度，默认为2
    
    // 如果移动距离超过阈值，标记为已移动
    if (Math.abs(walk) > (options.moveThreshold || 5)) {
      hasMoved = true;
    }
    
    el.scrollLeft = scrollLeft - walk;
    e.preventDefault();
    
    // 调用自定义的mouseMove回调（如果有）
    if (options && typeof options.onMouseMove === 'function') {
      options.onMouseMove(e, walk);
    }
  };
  
  // 添加事件监听
  el.addEventListener('mousedown', mouseDownHandler);
  el.addEventListener('mouseleave', mouseLeaveHandler);
  el.addEventListener('mouseup', mouseUpHandler);
  el.addEventListener('mousemove', mouseMoveHandler);
  
  // 保存引用以便后续移除
  el._dragScrollHandlers = {
    mouseDown: mouseDownHandler,
    mouseLeave: mouseLeaveHandler,
    mouseUp: mouseUpHandler,
    mouseMove: mouseMoveHandler
  };
}

function removeDragScroll(el) {
  if (el._dragScrollHandlers) {
    // 移除所有事件监听器
    el.removeEventListener('mousedown', el._dragScrollHandlers.mouseDown);
    el.removeEventListener('mouseleave', el._dragScrollHandlers.mouseLeave);
    el.removeEventListener('mouseup', el._dragScrollHandlers.mouseUp);
    el.removeEventListener('mousemove', el._dragScrollHandlers.mouseMove);
    
    // 移除类名
    el.classList.remove('drag-scroll-container');
    
    // 移除样式表
    if (el._dragScrollStyleSheet) {
      document.head.removeChild(el._dragScrollStyleSheet);
      delete el._dragScrollStyleSheet;
    }
    
    // 清除引用
    delete el._dragScrollHandlers;
  }
}